<template>
  <div class="orderContent">
    <AppNewHeader :userName="userName" :placeholderText="'请输入数据库名称'" />
    <div class="oederTable">
      <div class="tableTitle">知识库列表</div>

      <div
        class="tableBox"
        v-for="(item, index) in orderItems"
        :key="index"
        style="margin-bottom: 20px"
      >
        <div class="tabletext">
          <el-icon style="margin-left: 12px"><Shop /></el-icon>
          <span style="margin-left: 10px">{{ item.navi }}</span>
          <el-button
            @click="toggleCollapse(index)"
            type="text"
            style="margin-left: 10px"
          >
            {{ collapsed[index] ? "展开" : "收起" }}
          </el-button>
        </div>

        <el-table
          v-if="collapsed[index]"
          :data="[item.userorders[0]]"
          row-key="id"
          :show-header="false"
          :row-style="{ height: '30px', width: '100%' }"
          class="order-table"
        >
          <el-table-column show-overflow-tooltip property="orderName">
            <template #default="scope">
              {{ scope.row.orderName || "--" }}等知识库......
            </template>
          </el-table-column>
        </el-table>
        <el-table
          v-else
          :data="collapsed[index] ? [item.userorders[0]] : item.userorders"
          row-key="id"
          :row-style="{ height: '30px', width: '100%' }"
          class="order-table"
          :header-cell-style="{
            background: '#FAFAFA',
            color: '#606266',
            fontWeight: '600',
            color: '#333333',
            fontStyle: 'normal',
            fontSize: '16px',
            fontFamily: 'PingFangSC, PingFang SC',
          }"
        >
          <el-table-column show-overflow-tooltip property="orderName">
            <template #header>
              <div class="custom-header">
                <span>知识库名称</span>
              </div>
            </template>
            <template #default="scope">
              <div v-if="!collapsed[index] || scope.$index === 0">
                {{ scope.row.orderName || "--" }}
                <span v-if="collapsed[index]">等知识库......</span>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column
            v-if="!collapsed[index]"
            show-overflow-tooltip
            label="价格"
            property="orderAmount"
          >
            <template #default="scope">
              {{
                scope.row.orderAmount !== undefined &&
                scope.row.orderAmount !== null
                  ? scope.row.orderAmount
                  : "--"
              }}
            </template>
          </el-table-column> -->
          <el-table-column
            v-if="!collapsed[index]"
            show-overflow-tooltip
            label="年限"
            property="orderCount"
          >
            <template #default="scope">
              {{
                scope.row.orderCount !== undefined &&
                scope.row.orderCount !== null
                  ? scope.row.orderCount
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column
            v-if="!collapsed[index]"
            show-overflow-tooltip
            label="出版社"
            property="publishUnit"
          >
            <template #default="scope">
              {{
                scope.row.publishUnit !== undefined &&
                scope.row.publishUnit !== null
                  ? scope.row.publishUnit
                  : "--"
              }}
            </template>
          </el-table-column>
          <el-table-column v-if="!collapsed[index]" width="80" label="状态">
            <template #default="scope">
              {{ scope.row.status === "1" ? "正常使用" : "待处理" }}
            </template>
          </el-table-column>
        </el-table>

        <div class="tableBotText">
          <div class="tableBotList">
            <div class="tableItem">
              <div class="name">知识库数量：</div>
              <div class="value">{{ item.count2 }}个</div>
            </div>
            <div class="tableItem">
              <div class="name">销售负责人：</div>
              <div class="value">
                {{ item.userorders[0]?.saleUserName || "--" }}
              </div>
            </div>
            <div class="tableItem">
              <div class="name">销售联系电话：</div>
              <div class="value">
                {{ item.userorders[0]?.saleUserPhone || "--" }}
              </div>
            </div>
            <div class="tableItem">
              <div class="name">下单时间：</div>
              <div class="value">
                {{ item.userorders[0]?.createTime || "--" }}
              </div>
            </div>
            <!-- <div class="tableItem">
              <div class="name2">总价：</div>
              <div class="value2">
                ￥{{ calculateTotal(item.userorders) || "--" }}元
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>

    <div class="orderList">
      <el-pagination
        layout="prev, pager, next"
        :total="total"
        :page-sizes="pageSize"
        @current-change="handlePage"
      />
    </div>
    <el-footer>
      <AppFooter></AppFooter>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppFooter from "@/views/components/AppFooter.vue";
import { PostOrderByList } from "@/api/index.js";
import { Shop } from "@element-plus/icons-vue";
import { Cookie } from '@/utils/Cookie'
const orderItems = ref([]);
const pageSize = ref(10);
const pageIndex = ref(1);
const total = ref(1);
const collapsed = ref([]);
const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get('token')) || '';
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get('userInfo')) || null;
    const user = userString || null;   
        userName.value = user?.realName;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};
onMounted(() => {
  handlOrderByList();
  checkTokenStatus();

});

const handlOrderByList = async () => {
  try {
    if (typeof PostOrderByList !== "function") {
      console.log("PostOrderByList function is not defined");
      // console.log("PostOrderByList function is not defined");
    }

    const res = await PostOrderByList({
      pageIndex: pageIndex.value,
      pageSize: pageSize.value,
    });
    if (res && res.info) {
      if (res.info) {
        orderItems.value = res.info;
        if (res.total !== null && res.total !== undefined) {
          total.value = res.info.total;
          // 初始化所有表格为折叠状态
          collapsed.value = new Array(res.info.length).fill(true);
        } else {
          console.warn("res.info.total is null or undefined");
        }
      } else {
        console.warn("res.info.list is null or undefined");
      }
    } else {
      console.warn("res.info is null or undefined");
    }

    console.log(orderItems.value, " orderItems.value");
  } catch (error) {
    console.log(error);
  }
};

const handlePage = async (page) => {
  pageIndex.value = page;
  handlOrderByList();
};

const toggleCollapse = (index) => {
  collapsed.value[index] = !collapsed.value[index];
};

const calculateTotal = (orders) => {
  return orders
    .reduce((total, order) => {
      return total + parseFloat(order.orderAmount || 0);
    }, 0)
    .toFixed(2);
};
</script>

<style scoped>
.oederTable {
  padding: 0px 20px 0px 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 538px;
}
.order-table {
  border: none;
}
.order-table td {
  border-bottom: none;
}
.el-table--border::after,
.el-table--group::after {
  width: 0 !important;
}
.order-table th.is-leaf {
  border-bottom: none !important;
}
.order-table thead {
  border: none;
}
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}
.orderList {
  display: flex;
  justify-content: center;
}
::v-deep .el-table--enable-row-transition .el-table__body td.el-table__cell {
  border-bottom: none;
}
.custom-header {
  height: 54px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.tableBox {
  background: rgba(216, 216, 216, 0.02);
  border: 1px solid #e4e7ed;
  margin-top: 16px;
}
.tableBotText {
  display: flex;
  justify-content: right;
}
.tableBotList .tableItem {
  width: 342px;
  display: flex;
  justify-content: space-between;
  padding-top: 11px;
}
.tableBotList {
  padding: 3px 13px 17px 0;
}
.tableItem .name {
  width: 112px;
  text-align: right;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #999999;
  line-height: 22px;
  font-style: normal;
}
.tableItem .value {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: center;
  font-style: normal;
}
.tableItem .name2 {
  width: 112px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: right;
  font-style: normal;
}
.tableItem .value2 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 18px;
  color: #e73b3b;
  line-height: 25px;
  text-align: center;
  font-style: normal;
}
.tableTitle {
  height: 73px;
  line-height: 73px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 20px;
  color: #333333;
  text-align: left;
  font-style: normal;
  border-bottom: 1px solid #e4e7ed;
}
.tabletext {
  height: 55px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
  line-height: 55px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
}
::v-deep(.el-scrollbar__bar){
  display: none;
}
</style>
